<template>
  <div class="header-wrapper flex align-center">
    <div class="logo-box">社会组织评估填报系统</div>
    <div class="flex-sub flex align-center justify-end user-info">
      <div class="flex align-center margin-right">
        <img src="../assets/img/avatar.png" alt="" class="margin-right-xs">
        <p class="font-size">管理员</p>
      </div>
      <el-button type="primary"  size="small" class="font-size" @click="signOut">退出</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "header-modular",
  data() {
    return {}
  },
  computed:{
    user(){
      return this.$store.state.user
    }
  },
  created() {
  },
  methods: {
    signOut(){
      this.$confirm('您确定要退出吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.$store.state.user = null
        window.localStorage.clear()
        this.$router.replace('/login')
      })

    }
  },
}
</script>

<style scoped lang="scss">
.header-wrapper {
  width: 100%;
  height: 75px;
  background: #368ad1;

  .logo-box {
    padding: 0 30px;
    line-height: 75px;
    color: #fff;
    font-size: 28px;
    font-weight: bold;
    letter-spacing: 2px;
  }

  .user-info {
    padding: 0 30px;
    height: 75px;
    color: #fff;
  }

}
</style>
